import {Component, ElementRef, OnInit, ViewChild} from '@angular/core';
import {FormBuilder, FormGroup, Validators} from "@angular/forms";
import {UtilsService} from "../../../../shared/utils/utils.service";
import {
  LfsaBotonEditarGridComponent
} from "../../../../shared/components/lfsa-boton-editar-grid/lfsa-boton-editar-grid.component";
import {Workbook as wb} from "exceljs";
import {ModificacionMarcionesService} from "../../../horas-extras/services/modificacion-marcaciones.service";
import {moduloPerform} from '../../diccionarios/performValuesModulo';
import {
  ReportePerformService
} from "../../services/reporte-perform-services/parametro-conciliacion-bancaria.service";
import {DatosMaestrosService} from "../../../../services/datos-maestros.service";
import { DataGaussModel } from 'src/app/shared/components/graficos-high-chart/model/dataGaussModel';
import { LineaService } from '../../services/general-services/linea.service';
import { PlantaService } from '../../services/general-services/planta.service';
import { ActivatedRoute } from '@angular/router';
import { SeguimientoUserService } from '../../services/orden-proceso-services/seguimiento-user.service';

@Component({
  selector: 'app-reporte-gauss',
  templateUrl: './reporte-gauss.component.html',
  styleUrls: ['./reporte-gauss.component.css']
})
export class  ReporteGaussComponent implements OnInit {

  mostrarFormulario: boolean = false;
  mostrarGridLista: string = 'ListaCobros';
  titulo: string;
  DAT_TITULOS: any;
  DAT_BTNCSS: any;
  DAT_MSG: any;
  DAT_BTNS: any;
  textBoton: string;
  editableForm: boolean = false;
  formulario: FormGroup;
  formularioExtractos: FormGroup;
  loading: boolean = false;
  diccionarioModulo: any = {};
  frameworkComponents: any;
  columnDefs: any[];
  rowData: any[];
  rowSelection: any;
  gridApi: any;
  gridColumnApi: any;

  cmbPlanta: any[] = [];
  cmbLinea: any[] = [];


  gridApiPedidos: any;
  gridColumnApiPedidos: any;
  rowDataDetalle: any[];
  rowSelectionPedidos: any;
  columnDefsPedidos: any[];
  frameworkComponentsPedidos: any;

  gridApiExtractos: any;
  gridColumnApiExtractos: any;
  rowDataExtractos: any[];
  rowSelectionExtractos: any;
  columnDefsExtractos: any[];
  frameworkComponentsExtractos: any;

  rowSelected: any;
  rowSelectedExtractos: any;

  gaficoCompLoading:boolean =true;
  pesoRef:string = "";
  pesoSap:number = 0;
  promedio:number = 0;
  desviacionStd:string = "";
  textPeso:string = "Peso Bruto Referencial";
  numeroRegistros:number = 0;

  obligatorylocality: boolean = false;
  today: any;
  cmbDepartment: any[] = [];
  cmbEmployees: any[] = [];

  workbook: wb;
  data: any = [];
  dataExcel: any = [];
  uploadForm: FormGroup;
  actualWeek: number;
  mostrarTabla = false;
  recursosHumanos = false;
  @ViewChild('fileInput') fileInput: ElementRef;

  cmbEan14: any[] = [];
  cmbLote: any[] = [];
  cmbReceta: any[] = [];

  minimo:number = 0.01;
  maximo:number = 0.01;

  minimoAxis:number;
  maximoAxis:number;

  data_grafico_compuesto: DataGaussModel[] = [{
    name: 'EJEMPLO',
    data: []
  }];
  break = false;

  materialSelected: string = "";

  constructor(
    private fb: FormBuilder,
    private _modificacionMarcaciones: ModificacionMarcionesService,
    private _util: UtilsService,
    private _linea: LineaService,
    private _planta: PlantaService,
    private _paramReporte: ReportePerformService,
    private _datosMaestros: DatosMaestrosService,
    private rutaActiva         : ActivatedRoute,
    private _logServices : SeguimientoUserService,
  ) {
    this.diccionarioModulo = moduloPerform;
  }
  
  URI: string = 'REPORTE PERFOR GAUSS';

  ngOnInit(): void {
    this._logServices.saveSeguimientoPerform(this.URI); //Ticket 30238 LOG de ingreso en modulos perform

    console.log(this.rutaActiva.snapshot.queryParams);
    this.DAT_BTNS = moduloPerform.button.buttonsNombre;
    this.DAT_TITULOS = moduloPerform.titulos.autorizacionCobros;
    this.DAT_BTNCSS = moduloPerform.button.buttonsCss;
    this.DAT_MSG = moduloPerform.mensajes;
    this.titulo = this.DAT_TITULOS.tituloCardListar;
    //this.llenarCombos();
    //this.calculateCombos();
    this.formulario = this.fb.group({
      linea: ['', [Validators.required]],
      planta: ['', [Validators.required]],
      fechaIni: ['', [Validators.required]],
      fechaFin: ['', [Validators.required]],
      ean14: ['', [Validators.required]],
      lote: '',
      receta: ['', [Validators.required]],
      tolerancia:['',[Validators.required]]
    });
    this.precargarParametros(this.rutaActiva.snapshot.queryParams);
    this.formularioExtractos = this.fb.group({
      idBanco: '',
    });
    this.girdComponent();
    //this.cargarPerformReporteGauss();
  }

  validateForm() {
    return !(this.gridApiExtractos && this.gridApiExtractos.getSelectedRows() && this.gridApiExtractos.getSelectedRows().length > 0);
  }

  precargarParametros(parametros){
    this.gaficoCompLoading = true;
    if(parametros.ean14 == undefined){
      this.getAllPlanta();
      return;
    }
    this.materialSelected = parametros.material; //Ticket 26766 Problemas en plataforma PERFOR con referencia de artículos códigos EAN14

    this.formulario.get('fechaIni').setValue(parametros.fechaIni);
    this.formulario.get('fechaFin').setValue(parametros.fechaFin);
    this._planta.getAllbyPerfor().subscribe((res: any) => {
      this.cmbPlanta = res.respuesta;
      console.log(this.cmbPlanta.find((e) => e.id === Number(parametros.planta)));
      this.formulario.get('planta').setValue((this.cmbPlanta.find((e) => e.id === Number(parametros.planta))).id);
      this._linea.getByIdbyPerfor(parametros.planta).subscribe((res: any[]) => {
                                this.cmbLinea = res;
                                this.formulario.get('linea').setValue((this.cmbLinea.find((e) => e.id === Number(parametros.linea))).id);
                                this._paramReporte.getFindCodigoEan(this.formulario.get('fechaIni').value,
                                this.formulario.get('fechaFin').value,
                                this.formulario.get('lote').value,
                                "",
                                this.formulario.get('linea').value).subscribe((resp) => {
            this.cmbEan14 = resp.sort((a, b) => b.clave.localeCompare(a.clave));
            this.formulario.get('ean14').setValue((this.cmbEan14.find((e) => e.clave === parametros.ean14)).clave);
            if(this.cmbEan14.length === 0)
              this._util.alertifyToastWar('No existen valores desde \n'+
                                          this.formulario.get('fechaIni').value +' hasta '+
                                          this.formulario.get('fechaFin').value);
            this.loading = false;
            }, (error) => {
            this.loading = false;
            this.cmbEan14 = [];
            console.log(error);
            });
      }, (err) => {
        this.cmbLinea = [];
        console.log(err);
      });
    }, (err) => {
      this.cmbPlanta = [];
    });

    this.formulario.get('tolerancia').setValue(parametros.tolerancia);
    this.formulario.get('receta').setValue("0");
    this.formulario.get('lote').setValue("0");
    this.cmbLote.unshift({clave:"0",valor:"TODOS"});
    this.cmbReceta.unshift({clave:"0",valor:"TODOS"});

    //OBTIENE DETALLES DE TOTALES PESO, PROMEDIO DEL MATERIAL, MINIMOS Y MAXIMOS
    this._paramReporte.getFindReportGauss(parametros.fechaIni,
                                          parametros.fechaFin,
                                          parametros.ean14,
                                          '0',//receta
                                          '0',//Lote
                                          parametros.linea,
                                          parametros.tolerancia,
                                          0, //pesoSap?,
                                          this.materialSelected
                                          ).subscribe((resp) => {
        this.rowData = resp;
        //this.numeroRegistros = resp.length;
        //console.log("numero de registro->",this.numeroRegistros);
        if(resp.length>1){
          this.textPeso= "Peso Bruto Sap";
          this.pesoRef= resp[0].pesoReferencia;
          this.promedio= resp[0].promedio.toFixed(6);
          this.desviacionStd= resp[0].desviacionEstandar.toFixed(6);
          this.pesoSap = resp[0].pesoSap.toFixed(6);
          this.minimo = resp[0].toleranciaMin/100;
          this.maximo = resp[0].toleranciaMax/100;
        }
        if(this.pesoSap == 0){
          this.pesoSap = parseInt(this.pesoRef, 10);
          this.textPeso= "Peso Bruto Referencial";
        }

        //console.log(resp);
        const usersByLikes = resp.map(item => {
          //if(item.pesoBalanza > (item.promedio-(item.promedio*0.1))  && item.pesoBalanza < (item.promedio+(item.promedio*0.1)))
            return[item.pesoBalanza,Number(item.distribucion)];
          //else
            //return false;
        });
        this.data_grafico_compuesto = [{
          name: 'Distribución',
          data: usersByLikes
        }];
        this.minimoAxis = 0;
        this.minimoAxis = this.min(usersByLikes);
        this.maximoAxis = 0;
        this.maximoAxis = this.max(usersByLikes);
        this.gaficoCompLoading = false;
        this.loading = false;
        this.getCountRegisterDetails(true);
      }, (error) => {
        this.rowData = [];
        this.loading = false;
        console.log(error);
      });
  }

  getAllPlanta() {
    this._planta.getAllbyPerfor().subscribe((res: any) => {
      this.cmbPlanta = res.respuesta;
    }, (err) => {
      this.cmbPlanta = [];
    });
  }


  onGridReady(params) {
    this.gridApi = params.api;
    this.gridColumnApi = params.columnApi;
  }

  llenarCombos() {
    this.cargarAgencia();
  }

  onGridReadyPedidos(params) {
    this.gridApiPedidos = params.api;
    this.gridColumnApiPedidos = params.columnApi;
  }

  onGridReadyExtractos(params) {
    this.gridApiExtractos = params.api;
    this.gridColumnApiExtractos = params.columnApi;
  }

  cargarPerformReporteGauss(){
    this.gaficoCompLoading = true;
    this._paramReporte.getReporteGauss().subscribe((resp) => {
        //this.cmbEan14 = resp.sort((a, b) => b.clave.localeCompare(a.clave));
        this.pesoSap = 0;
        if(resp.length>1){
          this.textPeso= "Peso Bruto Sap";
          this.pesoRef= resp[0].pesoReferencia;
          this.promedio= resp[0].promedio.toFixed(6);
          this.desviacionStd= resp[0].desviacionEstandar.toFixed(6);
          this.pesoSap = resp[0].pesoSap.toFixed(6);
          if(this.pesoSap == 0){
            this.textPeso= "Peso Bruto Referencial";
            this.pesoSap = parseInt(this.pesoRef, 10);
          }

        }

        //console.log(resp);
        const usersByLikes = resp.map(item => {

          //if(item.pesoBalanza > (item.promedio-(item.promedio*0.08))  && item.pesoBalanza < (item.promedio+(item.promedio*0.08)))
            return[item.pesoBalanza,Number(item.distribucion)];
          //else
            //return false;
        });
        this.data_grafico_compuesto = [{
          name: 'Distribución',
          data: usersByLikes
        }];
        this.gaficoCompLoading = false;
        }, (error) => {
        this.cmbEan14 = [];
        console.log(error);
        });
  }



  girdComponent() {
    this.frameworkComponents = {
      buttonRenderer: LfsaBotonEditarGridComponent,
    };

    this.columnDefs = [
      {
        headerName: 'CANT.',
        field: 'cantidad',
        sortable: true,
        filter: true,
        width: 100
      },
      {
        headerName: 'ID MATERIAL',
        field: 'idMaterial',
        sortable: true,
        filter: true,
        width: 200
      },
      {
        headerName: 'DESCRIPCION',
        field: 'descMaterial',
        sortable: true,
        filter: true,
        width: 350
      },
      {
        headerName: 'EAN14',
        field: 'ean14',
        sortable: true,
        filter: true,
        width: 200
      },
      {
        headerName: 'LOTE',
        field: 'lote',
        sortable: true,
        filter: true,
        width: 150
      },
      {
        headerName: 'ESTADO',
        field: 'estado',
        sortable: true,
        filter: true,
        width: 200,
        valueGetter: function (params) {
          // debugger
          let data = params.data;
          switch(data.estado){
            case 1:
              return "CORRECTO";
            case 2:
              return "RECH. BAJO PESO";
            case 3:
              return "RECH. SOBRE PESO";
            case 4:
              return "RECH. CAJA ABIERTA";
            case 5:
              return "RECH. COD NO REGISTRADO";
            case 6:
              return "RECH. COD NO DEFINIDO";
            default:
              return "UNDEFINDED";
          }

      }
    }
    ];
    this.rowSelection = 'single';
  }


  girdComponentPedidos() {
    this.frameworkComponentsPedidos = {
      buttonRenderer: LfsaBotonEditarGridComponent,
    };

    this.columnDefsPedidos = [
      {
        headerName: 'CLIENTE',
        field: 'rowData.cobro.cliente.nombreCliente1',
        sortable: true,
        filter: true,
        width: 250
      },
      {
        headerName: 'VENDEDOR',
        field: 'rowData.cobro.vendedor.nombreVendedor1',
        sortable: true,
        filter: true,
        width: 250
      },
      {
        headerName: 'FORMA DE PAGO',
        field: 'rowData.pagoDetalle.tipoPago.descripcion',
        sortable: true,
        filter: true,
        width: 250
      },
      {
        headerName: 'AGENCIA',
        field: 'rowData.cobro.agencia.descripcion',
        sortable: true,
        filter: true,
        width: 100
      },
      {
        headerName: 'FECHA PEDIDO',
        field: 'pedFechaCreacion',
        sortable: true,
        filter: true,
        width: 200
      },
      {
        headerName: 'MONTO',
        field: 'pedValorPedido',
        sortable: true,
        filter: true,
        width: 200
      },
    ];
    this.rowSelectionPedidos = 'single';
  }

  obtainDate(){
    this.formulario.get('lote').setValue("");
    this.formulario.get('ean14').setValue("");
    this.formulario.get('receta').setValue("");
    this.cmbLote = [];
    if(this.formulario.get('fechaIni').value !== "" && this.formulario.get('fechaFin').value !== ""){
      console.log("GOTCHA");
      this.loading = true;
      this._paramReporte.getFindCodigoEan(this.formulario.get('fechaIni').value,
                                          this.formulario.get('fechaFin').value,
                                          this.formulario.get('lote').value,
                                          "1",
                                          this.formulario.get('linea').value).subscribe((resp) => {
        this.cmbEan14 = resp.sort((a, b) => b.clave.localeCompare(a.clave));
        this.cmbEan14 = this.cmbEan14.filter(obj => obj.valor !== 'TODOS');
        if(this.cmbEan14.length === 0)
          this._util.alertifyToastWar('No existen valores desde \n'+
          this.formulario.get('fechaIni').value +' hasta '+
          this.formulario.get('fechaFin').value);
          this.loading = false;
      }, (error) => {
        this.loading = false;
        this.cmbEan14 = [];
        console.log(error);
      });
    }
  }

  obtainLote(){
    this.cmbLote = [];
    this.formulario.get('lote').setValue("");
    if(this.formulario.get('fechaIni').value !== "" && this.formulario.get('fechaFin').value !== ""){
      console.log("GOTCHA");
      this._paramReporte.getFindCodigoLote(this.formulario.get('fechaIni').value,
                                          this.formulario.get('fechaFin').value,
                                          this.formulario.get('ean14').value,
                                          "",
                                          this.formulario.get('linea').value).subscribe((resp) => {
        this.cmbLote = resp.sort();
        if(this.cmbLote.length > 0)
          this.cmbLote.unshift({clave:"0",valor:"TODOS"});
      }, (error) => {
        this.cmbLote = [];
        console.log(error);
      });
    }
  }

  obtainReceta(event: Event){
    this.obtainLote();
    if(this.formulario.get('fechaIni').value !== "" && this.formulario.get('fechaFin').value !== ""){
      console.log("GOTCHA");

      const selectElement1 = event.target as HTMLSelectElement;
      const selectedText = selectElement1.options[selectElement1.selectedIndex].text;
      this.materialSelected = selectedText;
      console.log('Texto seleccionado:', this.materialSelected);
      this.getMaterialSelected();

      this._paramReporte.getFindReceta(this.formulario.get('fechaIni').value,
                                          this.formulario.get('fechaFin').value,
                                          this.formulario.get('ean14').value,
                                          this.formulario.get('linea').value).subscribe((resp) => {
          this.cmbReceta = resp.sort();
          this.cmbReceta.unshift({clave:"0",valor:"TODOS"});
          if(this.cmbReceta.length>0){
            this.formulario.get('receta').setValue(this.cmbReceta[0].clave);
          }

          //this.formulario.get('fechaIni').updateValueAndValidity();
      }, (error) => {
        this.rowData = [];
        this.loading = false;
        console.log(error);
      });
    }
  }

  generarGaussReport(){
    if(this.formulario.get('tolerancia').value <= 0){
      this._util.alertifyToastWar('La tolernacia no puede ser 0 o negativo');
      return;
    }
    this.loading = true;
    this.gaficoCompLoading = true;
    this.resetFieldReporte();
    
    if(this.formulario.get('fechaIni').value !== "" && this.formulario.get('fechaFin').value !== ""){
      console.log("GOTCHA");
      this._paramReporte.getFindReportGauss(this.formulario.get('fechaIni').value,
                                          this.formulario.get('fechaFin').value,
                                          this.formulario.get('ean14').value,
                                          this.formulario.get('receta').value,
                                          this.formulario.get('lote').value,
                                          this.formulario.get('linea').value,
                                          this.formulario.get('tolerancia').value,
                                          this.pesoSap,
                                          this.materialSelected
                                          ).subscribe((resp) => {
        this.rowData = resp;
        //this.numeroRegistros = resp.length;
        //console.log("numero de registro->",this.numeroRegistros);

        if(resp.length>1){
          this.textPeso= "Peso Bruto Sap";
          this.pesoRef= resp[0].pesoReferencia;
          this.promedio= resp[0].promedio.toFixed(6);
          this.desviacionStd= resp[0].desviacionEstandar.toFixed(6);
          this.pesoSap = resp[0].pesoSap.toFixed(6);
          this.minimo = resp[0].toleranciaMin/100;
          this.maximo = resp[0].toleranciaMax/100;
        }
        if(this.pesoSap == 0){
          this.pesoSap = parseInt(this.pesoRef, 10);
          this.textPeso= "Peso Bruto Referencial";
        }

        //console.log(resp);
        const usersByLikes = resp.map(item => {
          //if(item.pesoBalanza > (item.promedio-(item.promedio*0.1))  && item.pesoBalanza < (item.promedio+(item.promedio*0.1)))
            return[item.pesoBalanza,Number(item.distribucion)];
          //else
            //return false;
        });
        this.data_grafico_compuesto = [{
          name: 'Distribución',
          data: usersByLikes
        }];
        this.minimoAxis = 0;
        this.minimoAxis = this.min(usersByLikes);
        this.maximoAxis = 0;
        this.maximoAxis = this.max(usersByLikes);
        this.gaficoCompLoading = false;
        this.loading = false;
        this.getCountRegisterDetails(false);
      }, (error) => {
        this.rowData = [];
        this.loading = false;
        console.log(error);
      });
    }
  }


  girdComponentExtractos() {
    this.frameworkComponentsExtractos = {
      buttonRenderer: LfsaBotonEditarGridComponent,
    };

    this.columnDefsExtractos = [
      {
        headerName: '',
        sortable: true,
        filter: true,
        width: 300,
        checkboxSelection: true,
      },
      {
        headerName: 'BANCO ID',
        field: 'idBanco',
        sortable: true,
        filter: true,
        width: 100
      },
      {
        headerName: 'CUENTA',
        field: 'cuentaBancaria',
        sortable: true,
        filter: true,
        width: 150
      },
      {
        headerName: 'FECHA EXTRACTO',
        field: 'fechaExtracto',
        sortable: true,
        filter: true,
        width: 200
      },
      {
        headerName: 'NUMERO EXTRACTO',
        field: 'numeroExtracto',
        sortable: true,
        filter: true,
        width: 150
      },
      {
        headerName: 'NUMERO REFERENCIA',
        field: 'numeroReferencia',
        sortable: true,
        filter: true,
        width: 200
      },
      {
        headerName: 'MONTO',
        field: 'monto',
        sortable: true,
        filter: true,
        width: 200
      },
    ];
    this.rowSelectionExtractos = 'multiple';
  }


  rechazarCobro({rowData}) {
    this.loading = true;
    this._util.confirmarSincronoPromesa(
      {
        title: this.DAT_MSG.rechazar,
        text: ``,
        action: this.DAT_BTNS.rechazar,
        funcion: this._paramReporte.rechazarCobro(rowData),
      }
    ).then((res: any) => {
      this.gridApi.updateRowData({remove: this.gridApi.getSelectedRows()});
      this.loading = false;
    }, () => {
      this.loading = false;
    });
  }

  procesarExtractos({rowData}) {
    this.titulo = this.DAT_TITULOS.tituloCardProcesarExtractos;
    this.mostrarGridLista = 'ListaExtractos';
    this.textBoton = this.DAT_BTNS.procesar;
    console.log(rowData);

    this.formularioExtractos.get('idBanco').setValue(rowData && rowData.pagoDetalle && rowData.pagoDetalle.pagIdBancoContable ? rowData.pagoDetalle.pagIdBancoContable : '');
    this.getExtractos(rowData);
    //this.rowDataPedidos = rowData.pedidos;
    this.girdComponentExtractos();
  }



  concatenarBancoId(data: any[]) {
    return data = data.map(e => {
      let newDscaBanco = e.idBanco + ' - ' + e.dscaBanco;
      delete e['dscaBanco'];
      e.dscaBanco = newDscaBanco;
      return e;
    });
  }


  cargarAgencia() {
    this._datosMaestros.getAllOficinasVentas().subscribe((resp) => {
      //this.cmbAgencia = resp;
    }, (error) => {
      //this.cmbAgencia = [];
      console.log(error);
    });
  }

  procesarExtractosClick() {
    this.loading = true;
    //this.rowSelectedExtractos = rowData;

    this.rowSelectedExtractos = this.gridApiExtractos.getSelectedRows();

    let conciliacionDatos = this.rowSelectedExtractos.map(data =>
      ({
        idEmpresa: this.rowSelected && this.rowSelected.pagoDetalle && this.rowSelected.pagoDetalle.pagEmpresa ? this.rowSelected.pagoDetalle.pagEmpresa : '',
        idBanco: this.formularioExtractos && this.formularioExtractos.get('idBanco') && this.formularioExtractos.get('idBanco').value ? this.formularioExtractos.get('idBanco').value : '',
        claveBanco: data && data.claveBanco ? data.claveBanco : '',
        //cuentaBancaria: this.rowSelected && this.rowSelected.pagoDetalle && this.rowSelected.pagoDetalle.pagCtaBancaria ? this.rowSelected.pagoDetalle.pagCtaBancaria : '',
        cuentaBancaria: data && data.cuentaBancaria ? data.cuentaBancaria : '',
        numeroExtracto: data && data.numeroExtracto ? data.numeroExtracto : '',
        numeroReferencia: data && data.numeroReferencia ? data.numeroReferencia : '',
        idConciBancaDeta: data && data.idConciBancaDeta ? data.idConciBancaDeta : '',
      })
    );
    let payload = {
      cobroId: this.rowSelected && this.rowSelected.cobro && this.rowSelected.cobro.cobroId ? this.rowSelected.cobro.cobroId : '',
      pagConsecutivo: this.rowSelected && this.rowSelected.pagoDetalle && this.rowSelected.pagoDetalle.pagConsecutivo ? this.rowSelected.pagoDetalle.pagConsecutivo : 1,
      conciliacionDatos: conciliacionDatos
    };
    this._util.confirmarSincronoPromesa(
      {
        title: this.DAT_MSG.procesar,
        text: ``,
        action: this.DAT_BTNS.procesar,
        funcion: this._paramReporte.procesarCobro(payload),
      }
    ).then((res: any) => {
        this.loading = false;
        //this.cargarCobros();
        this.regresar();
      }, () => {
        this.loading = false;
      }
    );
  }

  getLineaPlanta() {
    this.formulario.get('linea').setValue('');
    this.formulario.get('fechaIni').setValue('');
    this.formulario.get('fechaFin').setValue('');
    this.formulario.get('ean14').setValue('');
    let idPlanta = this.formulario.get('planta').value;
    const planta = this.cmbPlanta.find((e) => e.id === idPlanta);
    console.log(planta);
    this._linea.getByIdbyPerfor(planta.id).subscribe((res: any[]) => {
      this.cmbLinea = res;
      if(this.cmbLinea.length>0)
        this.formulario.get('linea').setValue(this.cmbLinea[0].id);
    }, (err) => {
      this.cmbLinea = [];
      console.log(err);
    });
  }

  getExtractos(data) {
    let payload = {
      'fechaExtracto': this.formulario && this.formulario.get('date') && this.formulario.get('date').value ? this.formulario.get('date').value : '',
      'idBanco': this.formularioExtractos && this.formularioExtractos.get('idBanco') && this.formularioExtractos.get('idBanco').value ? this.formularioExtractos.get('idBanco').value : '',
      'idEmpresa': data && data.pagoDetalle && data.pagoDetalle.pagEmpresa ? data.pagoDetalle.pagEmpresa : '',
    };
    this.rowSelected = data;
    this.loading = true;
    this._paramReporte.getAllExtractoBancario(payload).subscribe((res: any) => {
      this.rowDataExtractos = res.map(data => (
        {
          ...data,
        }
      ));
      this.loading = false;
    }, () => {
      this.loading = false;
      this.rowDataExtractos = [];
    });
  }




  regresar() {
    this.formularioExtractos.reset();
    this.mostrarGridLista = 'ListaCobros';
    this.titulo = this.DAT_TITULOS.tituloCardListar;
  }


  acciones(event) {
    if (event === 'guardar') {
      this.procesarExtractosClick();
    } else {
      this.titulo = this.DAT_TITULOS.tituloCardListar;
      this.mostrarGridLista = 'ListaCobros';
    }
  }

  generateDetailedCSV(){
    this._paramReporte.getFindReportGaussDetail(this.formulario.get('fechaIni').value,
                                          this.formulario.get('fechaFin').value,
                                          this.formulario.get('ean14').value,
                                          this.formulario.get('receta').value,
                                          this.formulario.get('lote').value,
                                          this.formulario.get('linea').value,
                                          this.materialSelected
                                          ).subscribe((resp) => {
      this.rowDataDetalle = resp;
      this.exportCSVDetalle();
      this.exportCSV();
      //this.cmbTipoPago = resp;
    }, (error) => {
      //this.cmbTipoPago = [];
      console.log(error);
    });
  }

  exportCSV() {
    if(this.rowData === undefined || this.rowData.length === 0)
      return;
    const header: any[] = [["EAN_14","PESO_BALANZA","DISTRIBUCION",
    "PESO_REFERENCIA","PROMEDIO","DESVIACION_ESTANDAR"]];
    const listAux: any[] = this.rowData.map((item) => Object.assign({}, item));
    //console.log(this.rowData);
    const body: any[] = listAux.map(item => {

      return {
        ean14: '\''+item.ean14,
        pesoBalanza: item.pesoBalanza,
        distribucion: item.distribucion,
        pesoReferencia: item.pesoReferencia,
        promedio: item.promedio,
        desviacionEstandar:item.desviacionEstandar,
      }
    });
    this._util.exportCSV(header, body, "Reporte_Perform.csv");
  }

  exportCSVDetalle() {
    if(this.rowDataDetalle === undefined || this.rowDataDetalle.length === 0)
      return;
    const header: any[] = [["EAN_14","LOTE","RECETA","PROMEDIO","DESVIACION_ESTANDAR",
    "PESO_REFERENCIA","PESO_BALANZA","FECHA_RASP"]];
    const listAux: any[] = this.rowDataDetalle.map((item) => Object.assign({}, item));
    //console.log(this.rowDataDetalle);
    const body: any[] = listAux.map(item => {

      return {
        ean14: '\''+item.ean14,
        lote: item.lote,
        receta: item.receta,
        promedio: item.promedio,
        desviacionEstandar:item.desviacionEstandar,
        pesoReferencia: item.pesoReferencia,
        pesoBalanza: item.pesoBalanza,
        fechaRasp: item.fechaRasp,
      }
    });
    this._util.exportCSV(header, body, "Reporte_Perform_Detalle.csv");
  }

  min(arr){
    let value = [];
    let minValue = 30000;
    for (let i = 0; i < arr.length; i++) {
        if (arr[i][0] < minValue) {
          minValue = arr[i][0];
            value = arr[i];
        }
    }
    return minValue != 30000 ? minValue : this.minimoAxis;
  }

  max(arr){
    let value = [];
    let maxValue = 0;
    for (let i = 0; i < arr.length; i++) {
        if (arr[i][0] > maxValue) {
            maxValue = arr[i][0];
            value = arr[i];
        }
    }
    return maxValue != 0 ? maxValue : this.maximoAxis;
  }

  truncator(numToTruncate, intDecimalPlaces) {
    var numPower = Math.pow(10, intDecimalPlaces); // "numPowerConverter" might be better
    return ~~(numToTruncate * numPower)/numPower;
  }


  getCountRegisterDetails(callExternal : boolean) {

    let parameter = this.rutaActiva.snapshot.queryParams;

    if(callExternal == false){
      this._paramReporte.getFindReportGaussDetail(this.formulario.get('fechaIni').value,
        this.formulario.get('fechaFin').value,
        this.formulario.get('ean14').value,
        this.formulario.get('receta').value,
        this.formulario.get('lote').value,
        this.formulario.get('linea').value,
        this.materialSelected
      ).subscribe((resp) => {
        this.numeroRegistros = resp.length;
        console.log("numero de registro->",this.numeroRegistros);
      }, (error) => {
        //this.cmbTipoPago = [];
        console.log(error);
      });
    } else {
      this._paramReporte.getFindReportGaussDetail(parameter.fechaIni,
        parameter.fechaFin,
        parameter.ean14,
        '0',//receta
        '0',//Lote
        parameter.linea,
        this.materialSelected
      ).subscribe((resp) => {
        this.numeroRegistros = resp.length;
        console.log("numero de registro->",this.numeroRegistros);
      }, (error) => {
        //this.cmbTipoPago = [];
        console.log(error);
      });
    }

  }

  /* Obtiene Material en base a la selección del EAN, toma del text del combo de EAN donde viene el material.
  No se cambie la clave del combo para evitar afectaciones a otros procesos relacionados */
  getMaterialSelected(){
    if(this.materialSelected){
      let registro = this.materialSelected.split("-");
      this.materialSelected = registro[0].trim();
      console.log("Material Selected", this.materialSelected);
    }
  }

  resetFieldReporte(){
    this.pesoRef  = "";
    this.promedio = 0;
    this.pesoSap  = 0;
    this.minimo   = 0;
    this.maximo   = 0;
    this.desviacionStd= "";
  }

}
